import React from "react";

const conditions = [
  "Renal calculi",
  "Gall bladder calculi",
  "Female Disorders and infertility",
  "Skin and hair Diseases",
  "Gastrointestinal Disorders",
  "Lifestyle Disorders (Diabetes, Thyroid, PCOS and hormonal imbalance)",
  "Respiratory Diseases",
  "Joint Disorders",
  "All acute conditions",
];

const ConditionsWeTreat = () => {
  return (
    <section className="conditions" id="conditions">
      <div className="conditions-section">
        <div className="conditions-container">
          <h2 className="conditions-title">Conditions We Treat</h2>
          <ul className="conditions-list">
            {conditions.map((condition, index) => (
              <li key={index} className="condition-item">
                {condition}
              </li>
            ))}
          </ul>
        </div>
      </div>

    </section>
  );
};

export default ConditionsWeTreat;
